exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label.pre-intake--1FaPQYwxUCZv287H3iA96Z {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: start;\n  column-gap: .75rem;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.875rem;\n  color: #244861;\n  white-space: nowrap;\n}\n\nlabel.pre-intake--1FaPQYwxUCZv287H3iA96Z > *:first-child,\nlabel.pre-intake--1FaPQYwxUCZv287H3iA96Z + * {\n  margin-top: 0 !important;\n}\n", ""]);

// exports
exports.locals = {
	"fieldLabel": "pre-intake--1FaPQYwxUCZv287H3iA96Z",
	"fieldLabel": "pre-intake--1FaPQYwxUCZv287H3iA96Z"
};